import { v4 as uuid } from 'uuid';
export var createSessionId = function createSessionId() {
  return uuid();
};